import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Col, Row, Checkbox, Select, Button, Tabs } from "antd";
import { HeadersAuth } from "../funciones_utiles";
import { SelectCustom } from "./selectComponent";
import { AndroidOutlined, AppleOutlined } from '@ant-design/icons';
import { manejarError } from "../manejo_errores";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export const ModalPermisos = ({
  open,
  onClose,
  onChange,
  id_asociacion,
  setAlerta
}) => {
  const manejarAlertas = (tipo, mensaje) => {
		// Usar setAlerta para mostrar la alerta
		setAlerta({ message: mensaje, type: tipo });
	};
  const MySwal = withReactContent(Swal);
  const [tempDatosFormulario, setTempDatosFormulario] = useState({});
  const [permisos, setPermisos] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [adminsAsignados, setAdminsAsignados] = useState([]);
  const [nuevo, setNuevo] = useState(false);
  const [editar, setEditar] = useState(false);
  const [selectedPermisos, setSelectedPermisos] = useState([]);
  const [permisosApp, setPermisosApp] = useState(false);
  const [value, setValue] = useState([]);
  const [activeKey, setActiveKey] = useState("1");
  // console.log("permiso", permisosApp)

  useEffect(() => {
    if (id_asociacion !== null) {
      fetchPermisos();
      fetchAdmines();
      fetchAdminesAsignados();
    }
  }, [id_asociacion, open, onClose])

 useEffect(() => {
  if (id_asociacion !== null && tempDatosFormulario.id) {
    fetchPermisosApp();
  }
}, [id_asociacion, tempDatosFormulario.id]);


  useEffect(() => {
    if (open) {
      setActiveKey("1");
      setNuevo(true);
      setEditar(false);
    }
  }, [open]);

  useEffect(() => {
    setTempDatosFormulario({
      id: ""
    })
    setValue([]);
    setSelectedPermisos([]);
    setPermisosApp(false);
  }, [onClose])

  //Nuevo administrador

  const fetchPermisos = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_DOMINIO}/permisos`, 
        HeadersAuth);
      setPermisos(response.data)
      // console.log("permisos", response.data)
    } catch (error) {
      console.error("Error al obtener los permisos", error)
    }
  }

  const fetchAdmines = async () => {
		try {
      const idAsociacion = id_asociacion;

		  const response = await axios.get(
			`${process.env.REACT_APP_DOMINIO}/admin-nuevos/${idAsociacion}`,
			HeadersAuth
		  );
      const opcionesFormateadas = response.data.map((a) => ({
        ...a,
        adminCompleto: `${a.nombre} ${a.apellido}`
      }));
      setAdmins(opcionesFormateadas)
		  // console.log("admins", response.data)
		} catch (error) {
      console.error("Error al obtener los administradores disponibles", error)
		}
	};

  const asignarAdmin = async (selectedPermisos) => {
    try {
      if (!tempDatosFormulario.id) {
        MySwal.fire({
          text: "Debe seleccionar un administrador",
          icon: "warning",
          confirmButtonText: "Ok",
        })
        return;
      }
      // console.log("log", selectedPermisos.length === 0 && !permisosApp)
      if (selectedPermisos.length === 0 && !permisosApp) {
        MySwal.fire({
          text: "Seleccione al menos un permiso",
          icon: "warning",
          confirmButtonText: "Ok",
        })
        return;
      }
      const payload = {
        admin_id: parseInt(tempDatosFormulario.id),
        asociacion_id: id_asociacion,
        permisos: selectedPermisos,
      };
      // console.log("lo que se envía:", payload)
      const response = await axios.post(
        `${process.env.REACT_APP_DOMINIO}/admin-asociacion`,
        payload,
        HeadersAuth
      );
      // console.log("lo que se envía", payload)
      if (response.status == 200) {
        MySwal.fire({
          text: "Administrador asignado",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(() => {
          fetchAdmines();
          fetchAdminesAsignados();
          setTempDatosFormulario({});
          setSelectedPermisos([]);
        });
      } 
    } catch (error) {
      MySwal.fire({
        text: manejarError(error),
        icon: "error",
        confirmButtonText: "Ok",
      });
      console.error("Error al asignar administrador:", error);
    }
  };

  const onChanges = (key) => {
    setActiveKey(key)
    setNuevo(key === "1");
    setEditar(key === "2");
    
    setTempDatosFormulario({});
    setSelectedPermisos([]);
    setPermisosApp(false);
    setValue([]);
  };

  const handleChange = (e) => {
		const { id, value } = e.target;
		setTempDatosFormulario((prev) => ({
			...prev,
			[id]: value,
		}));
	};

  useEffect(() => {
    setSelectedPermisos(value);
  }, [open]);

  // Permisos admin app

  const permisosAdminApp = async (valorPermiso) => {
    try {
      if (!tempDatosFormulario.id) {
        MySwal.fire({
          text: "Debe seleccionar un administrador",
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return;
      }

      if (selectedPermisos.length === 0 && !valorPermiso) {
        MySwal.fire({
          text: "Seleccione al menos un permiso",
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return;
      }

      // console.log("lo que se envía:", id_asociacion, valorPermiso, tempDatosFormulario.id);

      const response = await axios.post(
        `${process.env.REACT_APP_DOMINIO}/permisos-app`,
        {
          asociacion_id: id_asociacion,
          adminApp: valorPermiso,
          admin_id: tempDatosFormulario.id,
        },
        HeadersAuth
      );

      if (response.status === 200) {
        // ✅ limpiar el estado antes del alert
        setPermisosApp(false);
        setTempDatosFormulario({});

        MySwal.fire({
          text: "Permisos asignados",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(() => {
          fetchAdmines();
          fetchAdminesAsignados();
        });
      }
    } catch (err) {
      MySwal.fire({
        text: manejarError(err),
        icon: "error",
        confirmButtonText: "Ok",
      });
      console.error("Error al asignar permisos app:", err);
    }
  };

  const fetchPermisosApp = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/permisosApp/${tempDatosFormulario.id}/${id_asociacion}`,
        HeadersAuth
      );
      const adminAppValue = response.data?.adminApp === true;
      setPermisosApp(adminAppValue);
      // console.log("Permisos app obtenidos:", adminAppValue);
    } catch (err) {
      MySwal.fire({
        text: manejarError(err),
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };


  const editarAdminApp = async () => {
    try {
      if (!tempDatosFormulario?.id) {
        MySwal.fire({
          text: "Seleccioná un administrador antes de editar.",
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return;
      }

      if (selectedPermisos.length === 0 && !permisosApp) {
        MySwal.fire({
          text: "Seleccione al menos un permiso o asigne permisos a la app",
          icon: "warning",
          confirmButtonText: "Ok",
        })
        return;
      }

      const response = await axios.put(
        `${process.env.REACT_APP_DOMINIO}/actualizar-asignacion-app`,
        {
          asociacion_id: id_asociacion,
          adminApp: permisosApp,
          admin_id: tempDatosFormulario.id,
        },
        HeadersAuth
      );

      if (response.status === 200) {
        MySwal.fire({
          text: "Permisos actualizados",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(() => {
          fetchPermisosApp();
        });
      }
    } catch (err) {
      MySwal.fire({
        text: manejarError(err),
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };


  //Editar administrador

  const fetchAdminesAsignados = async () => {
    try {
      const idAsociacion = id_asociacion;
      const response = await axios.get(
      `${process.env.REACT_APP_DOMINIO}/admin-asociacion/${idAsociacion}`,
      HeadersAuth
      );
      // console.log("asignados", response.data)
      const opcionesFormateadas = response.data.map((a) => ({
        ...a,
        adminCompleto: `${a.nombre} ${a.apellido}`
      }));
      setAdminsAsignados(opcionesFormateadas)
    } catch (error) {
      console.error("Error al obtener administradores asignados:", error);
    }
  };

  const handleAdminChange = async (e) => {
    const adminId = Number(e.target.value); 
    // console.log("Admin seleccionado:", adminId);

    if (!adminId) return;

    setTempDatosFormulario((prev) => ({
      ...prev,
      id: adminId
    }));

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/permisosAsignados/${adminId}/${id_asociacion}`,
        HeadersAuth
      );

      const permisosIds = response.data.map(p => String(p.idPermiso));
      setValue(permisosIds);
      setSelectedPermisos(permisosIds);
    } catch (error) {
      console.error("Error al obtener permisos asignados:", error);
      setValue([]);
    }
  };

  const editarAsignacion = async () => {
    try {
      if (!tempDatosFormulario?.id) {
        MySwal.fire({
          text: "Seleccioná un administrador antes de editar.",
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return;
      }

      if (selectedPermisos.length === 0 && !permisosApp) {
        MySwal.fire({
          text: "Seleccione al menos un permiso o asigne permisos a la app",
          icon: "warning",
          confirmButtonText: "Ok",
        })
        return;
      }

      if (!Array.isArray(selectedPermisos)) {
        MySwal.fire({
          text: "Los permisos no son válidos.",
          icon: "error",
          confirmButtonText: "Ok",
        });
        return;
      }

      const payload = {
        admin_id: tempDatosFormulario.id,
        asociacion_id: id_asociacion,
        permisos: selectedPermisos.map(id => Number(id)),
      };
      // console.log("lom que se envía:", payload)
      const response = await axios.put(
        `${process.env.REACT_APP_DOMINIO}/actualizar-asignacion/`,
        payload,
        HeadersAuth
      );

      if (response.status == 200) {
        MySwal.fire({
          text: "Permisos actualizados",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(() => {
          fetchAdminesAsignados();
          fetchPermisos();
        })
      } 
    } catch (error) {
      console.error("Error al editar administrador:", error);
      // manejarAlerta("error", "Error al editar administrador");
    }
  };

  const handleCheckboxChange = (checkedValues) => {
    // checkedValues viene como strings
    setValue(checkedValues);
    setSelectedPermisos(checkedValues);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = permisos.map(p => String(p.id)); // 👈 strings
      setValue(allIds);
      setSelectedPermisos(allIds);
    } else {
      setValue([]);
      setSelectedPermisos([]);
    }
  };

  const checkChange = (e) => {
    const adminApp = e.target.checked;
    setPermisosApp(adminApp);
    // console.log("log", adminApp)
  };

  const handleGuardar = () => {
    if (permisosApp !== false) {
      permisosAdminApp(permisosApp);
    }
    if (selectedPermisos.length !== 0) {
      asignarAdmin(selectedPermisos);
    }
  }

  const handleEditar = () => {
    editarAsignacion();
    editarAdminApp();
  }

  // console.log("values", value)
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <Tabs activeKey={activeKey} onChange={onChanges}>
        <Tabs.TabPane tab="Asignar nuevo" key="1">
          {nuevo && 
            <>
              {admins.length > 0 ? (
                <Row gutter={0}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    borderRadius: 5,
                    justifyContent: "space-between",
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    padding: 15,
                    marginBottom: 10,
                    gap: 10,
                  }}
                >
                  <Col xs={24} sm={14}>
                    <SelectCustom
                      idCampo={"id"}
                      nombreCampo={"Administrador"}
                      elPlaceholder={"Seleccioná un administrador"}
                      arrayOpciones={admins.length > 0 ? admins : []}
                      textoOpciones={"adminCompleto"}
                      required={true}
                      onChange={handleChange}
                      elValue={tempDatosFormulario.id || ""}
                    />
                  </Col>
                  <Col xs={24} sm={8}>
                    <Button
                      className="boton-principal"
                      style={{ fontSize: 16, width: "100%", marginTop: 20 }}
                      onClick={handleGuardar}
                    >
                      Asignar administrador
                    </Button>
                  </Col>
                </Row>
              ) : (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: 10
                  }}
                >
                  <p style={{ fontSize: "18px", color: "#000", fontWeight: "lighter" }}>No hay administradores para asignar en esta asociación.</p>
                </div>
              )}

              <div style={{ 
                display: "flex", 
                flexDirection: "row", 
                alignItems: "center",
                borderRadius: 5,
                justifyContent: "center",
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                padding: 15,
                marginBottom: 10,
                gap: 10 }}>
                <Checkbox
                  indeterminate={selectedPermisos.length > 0 && selectedPermisos.length < permisos.length}
                  checked={selectedPermisos.length === permisos.length && permisos.length > 0}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedPermisos(permisos.map((p) => p.id));
                      onChange?.(permisos.map((p) => p.id));  // notifico al padre si existe
                    } else {
                      setSelectedPermisos([]);
                      onChange?.([]);
                    }
                  }}
                />
                <span style={{ fontWeight: "bold", fontSize: "18px", color: "#000" }}>Seleccionar todos los permisos(Web)</span>
              </div>
              <Checkbox.Group
                style={{ width: "100%" }}
                value={selectedPermisos}
                onChange={(nuevos) => {
                  setSelectedPermisos(nuevos);
                  onChange?.(nuevos); // notifico al padre si existe
                }}
              >
                <Row gutter={16}>
                  {permisos.map((per) => (
                    <Col key={per.id} xs={24} sm={8}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          borderRadius: 5,
                          backgroundColor: "#fff",
                          color: "#BA1721",
                          border: "1px solid #ccc",
                          padding: 15,
                          marginBottom: 15,
                          height: "100px",
                          cursor: "pointer",
                        }}
                      >
                        <Checkbox value={per.id} style={{ marginBottom: 5 }}>
                          <span style={{ fontWeight: "bold", color: "#BA1721" }}>{per.nombre}</span>
                        </Checkbox>
                        <span style={{ fontSize: "12px", color: "#666" }}>
                          {per.descripcion}
                        </span>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
              <div style={{ 
                display: "flex", 
                flexDirection: "row", 
                alignItems: "center",
                borderRadius: 5,
                justifyContent: "center",
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                padding: 15,
                marginBottom: 10,
                gap: 10 }}
              >
                <span style={{ fontWeight: "bold", fontSize: "18px", color: "#000" }}>Seleccionar permisos(APP)</span>
              </div>
              <Col 
                xs={24} 
                sm={8}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 5,
                  backgroundColor: "#fff",
                  color: "#BA1721",
                  border: "1px solid #ccc",
                  padding: 15,
                  marginBottom: 15,
                  height: "100px",
                  cursor: "pointer",
                  alignSelf: "center",
                  justifyContent: "center"
                }}
              >
                <Checkbox
                  translate="no"
                  className="notranslate"
                  style={{ marginBottom: 5 }}
                  checked={Boolean(permisosApp)}          
                  onChange={(e) => setPermisosApp(e.target.checked)}  
                >
                  <span style={{ fontWeight: "bold", color: "#BA1721" }}>ADMINISTRADOR APP</span>
                </Checkbox>
                <span style={{ fontSize: "12px", color: "#666" }}>
                  Permite al usuario entrar a la app en modo administrador.
                </span>
              </Col>
            </>
          }
        </Tabs.TabPane>
        <Tabs.TabPane tab="Editar" key="2" >
          {editar && 
            <>
              {adminsAsignados.length > 0 ? (
              <Row gutter={0}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  borderRadius: 5,
                  justifyContent: "space-between",
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  padding: 15,
                  marginBottom: 10,
                  gap: 10,
                  width: "100%"
                }}
              >
                <Col xs={24} sm={14}>
                  <SelectCustom
                    idCampo={"id"} 
                    nombreCampo={"Administrador"}
                    elPlaceholder={"Seleccioná un administrador"}
                    arrayOpciones={adminsAsignados.length > 0 ? adminsAsignados : []}
                    textoOpciones={"adminCompleto"}
                    required={true}
                    onChange={handleAdminChange}
                    elValue={tempDatosFormulario?.id || ""}
                  />
                </Col>
                <Col xs={24} sm={8}>
                  <Button
                    className="boton-principal"
                    style={{ fontSize: 16, width: "100%", marginTop: 20 }}
                    onClick={handleEditar}
                  >
                    Editar administrador
                  </Button>
                </Col>
              </Row>
              ) : (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: 20,
                    marginBottom: 10
                  }}
                >
                  <p style={{ fontSize: "18px", color: "#000", fontWeight: "lighter", textAlign: "center" }}>No hay administradores asignados a esta asociación.</p>
                </div>
              )}

              {tempDatosFormulario.id && value ? (
                <>
                  <div style={{ 
                    display: "flex", 
                    flexDirection: "row", 
                    alignItems: "center",
                    borderRadius: 5,
                    justifyContent: "center",
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    padding: 15,
                    marginBottom: 10,
                    gap: 10 }}>
                    <Checkbox
                      indeterminate={value.length > 0 && value.length < permisos.length}
                      checked={value.length === permisos.length && permisos.length > 0}
                      onChange={handleSelectAll}
                    />
                    <span style={{ fontWeight: "bold", fontSize: "18px", color: "#000" }}>Seleccionar todos los permisos(Web)</span>
                  </div>
                  <Checkbox.Group
                    key={`${tempDatosFormulario?.id ?? 'no-admin'}-${id_asociacion ?? 'no-asoc'}`} // 👈 fuerza remount al cambiar
                    style={{ width: "100%" }}
                    value={value}
                    onChange={handleCheckboxChange}
                  >
                    <Row gutter={16}>
                      {permisos.map((per) => (
                        <Col key={per.id} xs={24} sm={8}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              borderRadius: 5,
                              backgroundColor: "#fff",
                              color: "#BA1721",
                              border: "1px solid #ccc",
                              padding: 15,
                              marginBottom: 15,
                              height: "100px",
                              cursor: "pointer",
                            }}
                          >
                            <Checkbox value={String(per.id)} style={{ marginBottom: 5 }}>
                              <span style={{ fontWeight: "bold", color: "#BA1721" }}>{per.nombre}</span>
                            </Checkbox>
                            <span style={{ fontSize: "12px", color: "#666" }}>
                              {per.descripcion}
                            </span>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Checkbox.Group>
                  <div style={{ 
                    display: "flex", 
                    flexDirection: "row", 
                    alignItems: "center",
                    borderRadius: 5,
                    justifyContent: "center",
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    padding: 15,
                    marginBottom: 10,
                    gap: 10 }}
                  >
                    <span style={{ fontWeight: "bold", fontSize: "18px", color: "#000" }}>Seleccionar permisos(APP)</span>
                  </div>
                  <Col 
                    xs={24} 
                    sm={8}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: 5,
                      backgroundColor: "#fff",
                      color: "#BA1721",
                      border: "1px solid #ccc",
                      padding: 15,
                      marginBottom: 15,
                      height: "100px",
                      cursor: "pointer",
                      alignSelf: "center",
                      justifyContent: "center"
                    }}
                  >
                    <Checkbox 
                      translate="no"
                      className="notranslate" 
                      style={{ 
                        marginBottom: 5
                      }}
                      onChange={checkChange}
                      checked={permisosApp}
                    >
                      <span style={{ fontWeight: "bold", color: "#BA1721" }}>ADMINISTRADOR APP</span>
                    </Checkbox>
                    <span style={{ fontSize: "12px", color: "#666" }}>
                      Permite al usuario entrar a la app en modo administrador.
                    </span>
                  </Col>
                </>
              ) : (
                ""
              )}   
            </>
          }
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  )
}